"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useCustomDrawerStyles = () => {
    const theme = (0, material_1.useTheme)();
    const container = {
        zIndex: 1000,
    };
    const paper = {
        width: '100%',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };
    const titleContainer = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };
    const content = {
        padding: '0 24px 16px 24px',
    };
    const header = {
        position: 'sticky',
        padding: '16px 0px',
        top: 0,
        zIndex: 1002,
        backgroundColor: theme.qlub.palette.white.main,
    };
    const title = {
        color: theme.qlub.palette.onSurfaceColors.highEmphasis,
    };
    const subTitle = {
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
    };
    return { container, paper, titleContainer, content, header, title, subTitle };
};
exports.default = useCustomDrawerStyles;
